"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumConciergePlanType = void 0;
exports.EnumConciergePlanType = {
    Goal: 'Goal',
    Topic: 'Topic',
};
//# sourceMappingURL=enum-concierge-plan-type.js.map